

<div class="row m-none align-items-center" *ngIf="(numberOfDaysOffset$ | async) as numberOfDaysOffset">
  <span class="col-8"> {{'wss.toggleOfferRequestValidators' | translate}} </span>
  <span class="col-4 border-left">
    <p-toggleswitch  [ngModel]="numberOfDaysOffset !== 2" (ngModelChange)="numberOfDaysOffsetChanged(numberOfDaysOffset)" data-testid="number-of-days-offset-2-toggle"></p-toggleswitch>
  </span>
</div>


